function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  className: "mgp-1",
  x: 7,
  y: 9,
  width: 23,
  height: 21,
  rx: 5,
  ry: 5
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  className: "mgp-1",
  x: 34,
  y: 9,
  width: 23,
  height: 21,
  rx: 5,
  ry: 5
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  className: "mgp-1",
  x: 7,
  y: 34,
  width: 23,
  height: 21,
  rx: 5,
  ry: 5
});

var _ref5 =
/*#__PURE__*/
React.createElement("rect", {
  className: "mgp-1",
  x: 34,
  y: 34,
  width: 23,
  height: 21,
  rx: 5,
  ry: 5
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default __webpack_public_path__ + "static/media/multiGamePlayIcon.274c4963.svg";
export { SvgComponent as ReactComponent };